import React from "react";
import * as moment from "moment";
import DragableList from "./DragableList";
import DayEnToFr from "../../utils/DayEnToFr";
import { useBestOf } from "../../context/BestOf";
import CoverPage from "./CoverPage";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  containerLayout: {
    display: "grid",
    gridTemplateColumns: "minmax(32%, auto) minmax(32%, auto) minmax(32%, auto)",
    gridColumnGap: "17px",
    gridRowGap: "17px",
    padding: "17px"
  },
  gridItem: {
    backgroundColor: theme.palette.background.paper,
    textAlign: "center",
    borderRadius: "10px",
    boxShadow: "0.5px 0.5px 2px #999",
  }
}));

const Layout = () => {
  const classes = useStyles();
  const { state } = useBestOf();
  return (
    <div className={classes.containerLayout}>
      {state.allDayBestOf.map((oneDay, index) => {
        let day = moment.utc(oneDay).format('dddd').toLowerCase();
        return (
          <div key={index} className={classes.gridItem}>
            <h3>{DayEnToFr(day)}</h3>
            <DragableList key={day} bestOffDay={state.postByDay[day]} day={day}/>
          </div>
        )
      })}
      <CoverPage/>
    </div>
  );
};

export default Layout;
